module.exports = __webpack_public_path__ + "img/driving_style_en.50d9249e.svg";